function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
var useStyles = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      position: 'relative'
    },
    button: function button(_ref2) {
      var variant = _ref2.variant,
          isLoading = _ref2.isLoading;
      return {
        '&.Mui-disabled': {
          backgroundColor: variant === 'text' && isLoading ? palette.greyTransparent[5] : ''
        }
      };
    },
    iconButton: function iconButton(_ref3) {
      var isLoading = _ref3.isLoading;
      return {
        '&.Mui-disabled': {
          backgroundColor: isLoading ? palette.greyTransparent[5] : ''
        }
      };
    },
    progress: function progress(_ref4) {
      var isIcon = _ref4.isIcon;
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: isIcon ? -18 : -12,
        marginLeft: isIcon ? -18 : -12
      };
    }
  };
}, {
  classNamePrefix: 'LoadingButton'
});

var LoadingButton = function LoadingButton(props) {
  var className = props.className,
      children = props.children,
      variant = props.variant,
      isLoading = props.isLoading,
      other = _objectWithoutProperties(props, ["className", "children", "variant", "isLoading"]);

  var isIcon = variant === 'icon';
  var classes = useStyles({
    variant: variant,
    isIcon: isIcon,
    isLoading: isLoading
  });
  return React.createElement("div", {
    className: clsx(classes.root, className)
  }, !isIcon && React.createElement(Button, _extends({
    className: classes.button,
    variant: variant,
    disabled: isLoading
  }, other), children), isIcon && React.createElement(IconButton, _extends({
    className: classes.iconButton,
    disabled: isLoading,
    "data-qa-selector": "loading-button-icon"
  }, other), children), isLoading && // NOTE: Aiming for 2px line thickness for loader at each size.
  // SVG icon for the circle loader is always 44 x 44 scaled down.
  // (44/36) * 2 = 2.4
  // (44/24) * 2 = 3.6
  React.createElement(CircularProgress, {
    className: classes.progress,
    size: isIcon ? 36 : 24,
    thickness: isIcon ? 2.4 : 3.6
  }));
};

LoadingButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained', 'icon']),
  isLoading: PropTypes.bool
};
LoadingButton.defaultProps = {
  className: '',
  variant: 'contained',
  isLoading: false
};
export default LoadingButton;